import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg font-bold">
                韩
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteConfig.name}
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              韩漫大全是一个免费观看韩国漫画的综合平台，致力于为华语读者提供最新、最全的韩漫资源。无需注册，免费阅读。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">全部分类</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">热血韩漫</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">恋爱韩漫</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/article/4" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">全知读者视角</Link></li>
              <li><Link to="/article/1" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">我独自升级</Link></li>
              <li><Link to="/article/2" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">剑尊归来</Link></li>
              <li><Link to="/article/7" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">女神降临</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">联系我们</Link></li>
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">常见问题</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-600">
            &copy; 2026 {siteConfig.name}. 本站所有漫画资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 text-foreground-400 hover:text-background-50 transition-colors" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 text-foreground-400 hover:text-background-50 transition-colors" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 text-foreground-400 hover:text-background-50 transition-colors" aria-label="QQ" rel="nofollow">
              <i className="ri-qq-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}